import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ExtranetRoutingModule } from './extranet-routing.module';
import { HomeComponent } from './home/home.component';
import { ReportInconsistentPscComponent } from './report-inconsistent-psc/report-inconsistent-psc.component';
import { SharedComponentsModule } from '../../shared/shared-components/shared-components.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { StandardsComponent } from './standards/standards.component';
import { AboutComponent } from './about/about.component';
import { FaqComponent } from './faq/faq.component';
import { ContactComponent } from './contact/contact.component';
import { PrivacyComponent } from './legals/privacy/privacy.component';
import {AboutSectionComponent} from './home/home-sections/about-section/about-section.component';
import {
  GlobalStandardsSectionComponent
} from './home/home-sections/global-standards-section/global-standards-section.component';
import {ContactsSectionComponent} from './home/home-sections/contacts-section/contacts-section.component';
import {FaqSectionComponent} from './home/home-sections/faq-section/faq-section.component';

@NgModule({
  declarations: [
    HomeComponent,
    ReportInconsistentPscComponent,
    StandardsComponent,
    AboutComponent,
    FaqComponent,
    ContactComponent,
    PrivacyComponent,
  ],
  imports: [
    CommonModule,
    ExtranetRoutingModule,
    SharedComponentsModule,
    FormsModule,
    ReactiveFormsModule,
    AboutSectionComponent,
    GlobalStandardsSectionComponent,
    ContactsSectionComponent,
    FaqSectionComponent
  ],
})
export class ExtranetModule {}
